<template>
  <div>
    <b-modal id="bv-modal-new-contact" hide-footer>
      <template #modal-title>New contact</template>

      <div class="row">
        <div class="col">
          <label class="form-label mb-2">Business Name</label>
          <input class="form-control2" v-model="contact.name" />
        </div>
      </div>

<div class="row">
        <div class="col">
          <label class="form-label mb-2">Email</label>
          <input class="form-control2" v-model="contact.email" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="form-label mb-2">Category</label>
          <select class="form-control2" v-model="contact.category">
            <option v-for="category in categories" :key="category" :value="category">
              {{ category }}
            </option>
          </select>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col">
          <label class="form-label mb-2">Location</label>
          <select class="form-control2" v-model="contact.location">
            <option v-for="location in locations" :key="location">
              {{ location }}
            </option>
          </select>
        </div>
      </div> -->

      <div class="row pt-3 pb-2">
        <div class="col">
          <div>
            <button
              v-if="updating"
              type="button"
              class="btn btn-danger submit col">
              <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button
              v-else
              type="button"
              class="btn btn-danger submit col"
              @click="saveEmail">Save</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from "../bus";

export default {
  props: [],

  data() {
    return {
      updating: false,
      categories: ['Autoshare', 'MyWebs'],
      contact: {
        email: null,
        name: null,
        category: 'Autoshare',
      },
      locations: [
        'Johannesburg',
        'Cape Town',
        'Durban',
        'Pretoria',
        'Port Elizabeth',
        'East London',
        'Bloemfontein',
        'Kimberley',
        'Polokwane',
        'Nelspruit',
        'South Africa',
      ],
    };
  },

  methods: {
    clearInfo() {
      this.contact = {
           email: null,
           name: null,
           category: 'Autoshare',
        };
    },

    hideModalNewContact() {
      this.$bvModal.hide("bv-modal-new-contact");
    },

    saveEmail() {
      if (!this.contact.email) { this.sweetfire("Email is required"); }
      else {

        this.updating = true;

        axios
          .post(`/contacts/new`, { contact: this.contact })
          .then((response) => {
            this.hideModalNewContact();
            EventBus.$emit("get-contacts");
          })
          .catch((error) => {
            this.sweetfire(error.response.data.message);
          })
          .finally(() => {
            this.updating = false;
          });
      }
    },

  },
};
</script>

<style scoped>
textarea.form-control2 {
  font-size: 0.9rem !important;
}

</style>